import MainLayout from '../../components/Layouts/MainLayout/MainLayout';
import InterestForm from '../../components/Forms/InterestForm/InterestForm'

import styles from './Interest.module.css';


const Interest= () => {

	return(
		<MainLayout>
			<div className='col-12 col-md-6 offset-md-3'>
				<div className={styles.FormWrapper}><InterestForm /></div>
			</div>
		</MainLayout>
	)

}

export default Interest;